/** @format */

import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../constants/api";
import { TAPICustomerListSuccess } from "../../redux-modules/declarations/apis/customers";
import apiClient from "../../utils/apiClient";

export const apiCustomerList = (): Promise<AxiosResponse<TAPICustomerListSuccess>> =>
  apiClient.get(API_ENDPOINTS.CUSTOMER_LIST);
